import { z } from 'zod';
import { Uuid } from './common';

export const Nozzle = z
  .enum(['main', 'aux'])
  .describe('`main` = bico principal (extruder 1), `aux` = bico auxiliar (extruder 2).');
export type Nozzle = z.infer<typeof Nozzle>;

export const SlicedSlot = z.object({
  slot: z.number().int().describe('Filament number in the slicer project (1-based).'),
  type: z.string().describe('Material as the slicer names it, e.g. "PLA".'),
  color: z.string().nullable(),
  profile: z
    .string()
    .nullable()
    .describe('Slicer filament profile, e.g. "Bambu PLA Basic @BBL X2D".'),
  grams: z.number(),
  meters: z.number().nullable(),
  nozzle: Nozzle.nullable().describe('null when the file does not say: let the user choose.'),
  forSupport: z.boolean(),
  suggestedFilamentId: Uuid.nullable().describe(
    'Catalog filament of the same material with the closest color.',
  ),
});
export type SlicedSlot = z.infer<typeof SlicedSlot>;

export const SlicedPlate = z.object({
  index: z.number().int(),
  name: z.string().nullable(),
  sliced: z.boolean().describe('false for project plates that were not part of the sliced export.'),
  printSeconds: z.number().int().nullable(),
  weightGrams: z.number().nullable(),
  thumbnailFileId: Uuid.nullable(),
  slots: z.array(SlicedSlot),
});
export type SlicedPlate = z.infer<typeof SlicedPlate>;

export const SlicerParseBody = z.object({
  fileId: Uuid.describe('A file uploaded with `POST /files?kind=sliced`.'),
});

export const SlicerParseResult = z
  .object({
    fileId: Uuid,
    format: z.enum(['3mf', 'gcode']),
    printer: z.object({
      model: z.string().nullable(),
      profile: z.string().nullable(),
      nozzleDiameter: z.number().nullable(),
    }),
    processProfile: z.string().nullable(),
    plates: z.array(SlicedPlate),
    suggestedPrinterId: Uuid.nullable(),
    warnings: z.array(z.string()).describe('pt-BR notes for the person quoting.'),
  })
  .meta({ id: 'SlicerParseResult' });
export type SlicerParseResult = z.infer<typeof SlicerParseResult>;
